/**
 * Created by DejanK on 9/3/2016.
 *
 * rbLoadingComponent
 */
import './rb-loading.scss';
import HTML from './rb-loading.html';

export default {
  template: HTML,
  bindings: {
    label: '@',
    classes: '@'
  }
};
